import { useContext, useState } from "react";
import {Dialog} from "@mui/material";
import { LanguageContext } from "../../utils/context/languageContext";
import Header from "../Header";
import VideoPlayer from "./VideoPlayer";
import { ScanErrorMessageProps } from "../../types/interfaces";
import { generateUuid, handleErrorMessage } from "../../utils/utils";
import { GENDER, VIDEO_POSTER_GENDER_BASED } from "../../utils/constants";
import SpecificButton from "../../atoms/specificButton/SpecificButton";
import { LanguageKeys } from "../../utils/languageKeys";
import { X } from "lucide-react";
import { useConfig } from "../../utils/context/configContext";

function ScanErrorMessage({ scanFailsError, onNext, gender, setScanUniqueKey, setIsVideoUploaded }: ScanErrorMessageProps) {
	const { translate } = useContext(LanguageContext) || {};
	const resolvedConfig = useConfig();
	const [showModal, setShowModal] = useState(false);

	const handleBtnClick = () => {
		if (onNext) {
			onNext?.();
		} else {
			setScanUniqueKey?.(generateUuid());
		}
		setIsVideoUploaded?.(false);
	};

	const handleShowModal = () => {
		setShowModal(!showModal);
	};


	return (
		<>
			<div data-testid="scan-error-message" className="flex common-ui-main flex-col h-full max-w-[28rem] mx-auto w-full rounded-t-[20px] overflow-y-auto" style={{ background: resolvedConfig?.style?.base?.backgroundColor }}>
				<div className="w-full  max-w-[28rem] mx-auto pt-[1rem] px-[1rem]">
					<Header noTitle />
				</div>
				<div className="flex-1">
					{scanFailsError && (
						<div className="px-[1rem]">
							<h2
								className="text-center"
								style={{
									fontFamily: resolvedConfig?.style?.heading?.headingFontFamily || "SeriouslyNostalgic Fn",
									fontSize: resolvedConfig?.style?.heading?.headingFontSize || "32px",
									color: resolvedConfig?.style?.heading?.headingColor || "#000",
									fontWeight: resolvedConfig?.style?.heading?.headingFontWeight || "normal",
								}}
							>
								{translate?.(LanguageKeys.issueWithScan)}
							</h2>
							<p
								style={{
									fontFamily: resolvedConfig?.style?.base?.baseFontFamily || "Inter, sans-serif",
									fontSize: resolvedConfig?.style?.base?.baseFontSize || "16px",
									color: resolvedConfig?.style?.base?.baseTextColor || "#1E1E1E",
								}}
							>
								{translate?.(LanguageKeys.reason)}
							</p>
							<p
								style={{
									fontFamily: resolvedConfig?.style?.base?.baseFontFamily || "Inter, sans-serif",
									fontSize: resolvedConfig?.style?.base?.baseFontSize || "16px",
									color: resolvedConfig?.style?.base?.baseTextColor || "#1E1E1E",
								}}
							>
								{handleErrorMessage(scanFailsError)}
							</p>

							<img className="my-[0.5rem] aspect-[2/1.4] w-full object-cover" onClick={handleShowModal} src={VIDEO_POSTER_GENDER_BASED[gender]} alt="icon" />
						</div>
					)}
				</div>
				{scanFailsError && (
					<div className="p-[1rem] flex gap-[0.5rem]">
						<SpecificButton data-testid="scan-again-btn" disabled={false} buttonText={translate?.(LanguageKeys.scanAgain)} className="!shadow-none" buttonFunc={handleBtnClick} />
					</div>
				)}
			</div>
			{showModal && (
				<Dialog className="w-screen h-screen video-modal" onClose={handleShowModal} open={showModal}>
					<div className="flex justifyEnd ">
						<span className="closeBtn" onClick={handleShowModal}>
							<X className="absolute right-[8px] top-[8px] text-white z-[9]" />
						</span>
					</div>
					<div className="aspect-video object-cover rounded-[20px] ">
						<VideoPlayer link={gender ? GENDER[gender].PRE_LINK : GENDER.male.PRE_LINK} wrapperClassName="w-screen h-screen fixed top-[0] left-[0]" />
					</div>
				</Dialog>
			)}
		</>
	);
}

export default ScanErrorMessage;
